import { Icon } from "@chakra-ui/react";
import React from "react";
import {
  getTwoToneChakraColors,
  TwoToneIconProps,
} from "./getTwoToneChakraColors";

export function SiHifo({
  colorScheme = "primary",
  primaryShade = 600,
  secondaryShade = 200,
  ...props
}: TwoToneIconProps) {
  const { primaryColor, secondaryColor } = getTwoToneChakraColors({
    colorScheme,
    primaryShade,
    secondaryShade,
  });

  return (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
      <line
        x1="16"
        y1="12"
        x2="16"
        y2="26"
        stroke={secondaryColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 11.8L14.9722 5.73534C15.4808 5.21881 16.3119 5.21247 16.8284 5.72118L23 11.8001"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
}
